import { render, staticRenderFns } from "./HrmDataTable.vue?vue&type=template&id=32cb4494"
import script from "./HrmDataTable.vue?vue&type=script&lang=ts"
export * from "./HrmDataTable.vue?vue&type=script&lang=ts"
import style0 from "./HrmDataTable.vue?vue&type=style&index=0&id=32cb4494&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports